import ChangePassword from './screen';
import { connect } from 'react-redux';
import { changePassword, Logout } from '../../../../redux/actions';
//import { Logout } from '../../../redux/actions/CommonActions';

const mapStateToProps = (state) => {
  return {
    userId: state.CommonReducer.userId,
    sessionToken: state.CommonReducer.sessionToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    Logout: () => dispatch(Logout()),
    changePassword: (requestBody, success, openSnackbar) =>
      dispatch(changePassword(requestBody, success, openSnackbar)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
